import { find } from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Processes from "~/components/Processes";
import ProcessosFormHandler from "~/components/ProcessosFormHandler";
import ProtectedPage from "~/components/security/ProtectedPage";
import Tasks from "~/components/Tasks";
import WidgetContainer from "~/components/WidgetContainer";
import ContentContainer from "~/containers/ContentContainer";
import ApplicationMenu from "~/containers/Menus_v2/components/ApplicationMenu";
import {
  addItemsToMenu,
  getMenusByApplication,
} from "~/store/ducks/applicationMenu/actionTypes";
import { BPM_MIDDLEWARE, CLAIMSMGT_APP } from "~/utils/constants";
import LiftworldPage from "../Liftworld/pages/LiftworldPage";
import AuxTablesPage from "../Liftworld/pages/AuxTablesPage";
import TablesPage from "../Anacom/pages/TablesPage";

const Anacom = (props) => {
  const { isMongoOn } = props;
  let { path } = useRouteMatch();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.globalReducer);
  const { rawMenus, menu } = useSelector(
    (state) => state.applicationMenuReducer
  );

  useEffect(() => {
    if (user.legacyUsers) {
      let userBPM = user.legacyUsers.find(
        (item) => item.legacyApplication.label === BPM_MIDDLEWARE.context
      );
      let username = userBPM ? userBPM.username : null;
      username && dispatch(getMenusByApplication(username, CLAIMSMGT_APP));
    }
  }, [user, dispatch]);

  useEffect(() => {
    const processosMenu = find(menu, {
      name: `menu.${CLAIMSMGT_APP}.processos`,
    });
    let items = [];
    let submenus;
    if (processosMenu) {
      const extraConfiguration_ = JSON.parse(
        processosMenu.extraConfiguration || false
      );
      submenus = extraConfiguration_.submenus
        ? extraConfiguration_.submenus
        : null;
      if (submenus) {
        Object.keys(submenus).forEach((key) => {
          //check if submenu has children
          let hasChildren = false;
          if (submenus[key].length == 0) hasChildren = false;
          else {
            submenus[key].every((flowid) => {
              const res = rawMenus.every((rm) => {
                //find flowid
                if (rm.url) {
                  let arr = rm.url.split("flowid=");
                  const flowid_ = arr[1];
                  if (flowid_ == flowid) {
                    hasChildren = true;
                    return false;
                  }
                  return true;
                }
                return true;
              });
              return res;
            });
          }
          if (hasChildren) {
            items.push({
              id: key,
              name: key,
              submenu: true,
              route: `${BPM_MIDDLEWARE.context}/processos/submenu/${key}`,
              menuParent: processosMenu ? processosMenu.id : null,
            });
          }
        });
      }
      const getProcessosMenuId = () =>
        processosMenu ? processosMenu.id : null;
      const getSubMenuParentId = (url) => {
        if (url) {
          let arr = url.split("flowid=");
          const flowId = arr[1];
          let id = getProcessosMenuId();
          Object.keys(submenus).forEach((key) => {
            if (submenus[key].some((i) => i == flowId)) {
              id = key;
            }
          });
          return id;
        } else return getProcessosMenuId();
      };
      rawMenus.forEach((item) => {
        items.push({
          name: item.label,
          url: item.url,
          route: `${CLAIMSMGT_APP}/processos/form/${item.label}`,
          menuParent: submenus
            ? getSubMenuParentId(item.url)
            : getProcessosMenuId(),
        });
      });
      dispatch(addItemsToMenu(items));
    }
  }, [rawMenus, menu, dispatch]);

  return (
    <>
      <ApplicationMenu applicationName={CLAIMSMGT_APP} showMenu={true} />
      <Switch>
        <Route path={`${path}/reclamacoesAnacomPoc`}>
            <ProtectedPage
              roles={[
                "ADMIN",
                "BUDGETMGRUser",
                "BUDGETMGRJunior",
                "BUDGETMGROrgGroupAdmin",
              ]}
            >
              <TablesPage/>
            </ProtectedPage>
          </Route>
      </Switch>
    </>
  );
};
export default Anacom;
